import { Badge } from '../../components/ui/badge';
import { CheckCircle2, Clock, AlertTriangle, type LucideIcon } from 'lucide-react';
import type { SupplierUploadStatus } from '../../lib/api/barratt';

const STATUS_STYLES: Record<SupplierUploadStatus, { icon: LucideIcon; className: string; label: string }> = {
  uploaded: { icon: CheckCircle2, className: 'bg-green-50 text-green-700 border-green-200', label: 'Uploaded' },
  pending: { icon: Clock, className: 'bg-yellow-50 text-yellow-700 border-yellow-200', label: 'Pending' },
  overdue: { icon: AlertTriangle, className: 'bg-red-50 text-red-700 border-red-200', label: 'Overdue' },
};

interface UploadStatusBadgeProps {
  status: SupplierUploadStatus;
  /** Server display label when available; falls back to the built-in one. */
  label?: string;
}

/** Pending / Uploaded / Overdue pill for a monthly upload obligation. */
export default function UploadStatusBadge({ status, label }: UploadStatusBadgeProps) {
  const style = STATUS_STYLES[status] ?? STATUS_STYLES.pending;
  const Icon = style.icon;
  return (
    <Badge variant="outline" className={style.className}>
      <Icon className="h-3 w-3 mr-1" />
      {label || style.label}
    </Badge>
  );
}
